import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const SET_SELECTED_FACILITY = `WORK_ORDERS_PAGE_SET_SELECTED_FACILITY`;

export interface IWorkOrdersPagesAC {
  type: typeof SET_SELECTED_FACILITY;
  selectedFacility: racehorse360.IFacility;
}

export const setSelectedFacility = (
  selectedFacility: racehorse360.IFacility
): Pick<IWorkOrdersPagesAC, "type" | "selectedFacility"> => {
  return {
    type: SET_SELECTED_FACILITY,
    selectedFacility
  };
};
